import { observer } from 'mobx-react';
import { useState } from 'react';
import {
  Box,
  Button,
  Collapse,
  Flex,
  Text,
  UnstyledButton,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useWaitingStateStore } from '../../../../store';
import { useParticipantDataStore } from '../../../../store/ParticipantDataStore';
import { MyIcon } from '@web/common-ui';

const COLLAPSE_ID = 'bag-survey-collapse';

export const BagSurveyBanner = observer(() => {
  const { t } = useTranslation('waiting-screen');
  const { baselineSurveyFilledOut } = useWaitingStateStore();
  const { bagSurvey } = useParticipantDataStore();
  const horizon0 = bagSurvey.horizon0;
  const [expanded, setExpanded] = useState(false);

  // hidden until the baseline survey is filled out
  if (
    !baselineSurveyFilledOut ||
    horizon0?.filledOut ||
    !horizon0?.surveyLink
  ) {
    return null;
  }

  return (
    <Box
      p="12px 20px 12px 16px"
      w="100%"
      bg="#FBFBF8"
      style={{
        borderLeft: '4px solid #e53e3e',
        borderBottom: '1px solid #edece8',
      }}
    >
      <UnstyledButton
        onClick={() => setExpanded((prev) => !prev)}
        w="100%"
        display="flex"
        style={{ alignItems: 'center' }}
        type="button"
        aria-expanded={expanded}
        aria-controls={COLLAPSE_ID}
      >
        <Flex justify="space-between" align="center" w="100%">
          <Flex align="center" gap="12px">
            <Flex
              w={42}
              align="center"
              justify="center"
              style={{ flexShrink: 0 }}
            >
              <MyIcon name="info" style={{ width: 28, height: 28 }} />
            </Flex>
            <Text fw={700} size="16px" c="#202020" lh="1">
              {t('BagSurveyBanner.Title')}
            </Text>
            <Text size="16px" c="#666" visibleFrom="sm" lh="1">
              {t('BagSurveyBanner.ShortDescription')}
            </Text>
          </Flex>
          <MyIcon
            name={expanded ? 'arrow_up' : 'arrow_down'}
            style={{ flexShrink: 0, display: 'block' }}
          />
        </Flex>
      </UnstyledButton>

      <Collapse in={expanded} id={COLLAPSE_ID}>
        {expanded && (
          <Box pt="16px">
            <Text size="16px" c="#202020" mb="12px" lh="1.6">
              {t('BagSurveyBanner.Description')}
            </Text>
            <Button
              component="a"
              href={horizon0.surveyLink}
              target="_blank"
              rel="noopener noreferrer"
              size="sm"
            >
              {t('BagSurveyBanner.LinkText')}
            </Button>
          </Box>
        )}
      </Collapse>
    </Box>
  );
});
